// extracted by mini-css-extract-plugin
export default {"btn_submit":"FormInput_btn_submit__U24ib","item-wp":"FormInput_item-wp__XMZPc","wrapper":"FormInput_wrapper__ufvUX"};